import { showError } from "../ui/Message";
import { pubCall } from "../utils/PubSub";
import { FILTER } from "../utils/Struct";
import { purgeReplace, updateOrdering } from "../utils/Utils";
import ConditionOnly from "./report_filters/ConditionOnly";
import GenericConditional from "./report_filters/GenericConditional";
import GenericDoubleValue from "./report_filters/GenericDoubleValue";
import GenericSingleValue from "./report_filters/GenericSingleValue";
import OptionalInputs from "./report_filters/OptionalInputs";
import RangeConditional from "./report_filters/RangeConditional";
import RangeDynamic from "./report_filters/RangeDynamic";
import SalesCustomerTypes from "./report_filters/SalesCustomerTypes";
import SelectBisac from "./report_filters/SelectBisac";

export default function ReportsFilterEdit(props) {

  const {
    controller = "",
    filter = {},
    callback = () => { },
    where_type = "AND",
    report = {},
    edit = false,
    setReport = () => { }
  } = props;

  let value = filter.value;
  if (filter?.type) {
    value = filter.type;
  }

  const handleSave = (_f, edit = false) => {
    if (_f) {

      _f.where_type = where_type;

      let filter_id = ""

      if (edit?.filter_id) {
        filter_id = edit.filter_id;
        _f.type = edit.type;
      } else {
        _f.filter_id = "";
      }

      let _filters = purgeReplace(report.filters, _f, "type", filter_id);
      _filters = updateOrdering(_filters);

      pubCall("report.purgeAndReplaceFilters", { report_id: report.report_id, filters_info: _filters }, (_s, _r) => {
        if (_s) {
          setReport(_r);
          callback()
        } else {
          showError(_r);
        }
      })

    }
    else {
      callback();
    }

  };

  switch (value) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
    case 6:
    case 7:
      return <GenericConditional controller={controller} edit={edit} filter={filter} onClose={() => callback()} onSave={handleSave} />;
    case 8:
       return <RangeConditional controller={controller} edit={edit} include_compare filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 9:
      return <RangeConditional controller={controller} edit={edit} include_compare filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 10:
      return <RangeConditional controller={controller} edit={edit} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 11:
      return <GenericSingleValue controller={controller} edit={edit} inputParams={{ maxLength: 4, width: 70, uppercase: true, }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 12:
      return <RangeConditional controller={controller} edit={edit} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 13:
      handleSave({ ...FILTER, type: filter.value });
      return;
    case 14:
      return <GenericSingleValue controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 170, uppercase: true, }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 15:
      return <GenericSingleValue controller={controller} edit={edit} inputParams={{ maxLength: 15, width: 170, uppercase: true, }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 16:
      handleSave({ ...FILTER, type: filter.value });
      return;
    case 17:
      return <OptionalInputs controller={controller} edit={edit} inputParams={{ maxLength: 2, width: 40, uppercase: true, }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 18:
       return <GenericSingleValue controller={controller} category edit={edit} inputParams={{ maxLength: 8, width: 120, uppercase: true, }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 19:
      return <GenericSingleValue controller={controller} subcategory edit={edit} inputParams={{ maxLength: 8, width: 120, uppercase: true, }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 20:
      return <GenericDoubleValue controller={controller} category edit={edit} inputParams={{ maxLength: 8, width: 120, uppercase: true, }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 21:
      return <OptionalInputs controller={controller} edit={edit} inputParams={{ maxLength: 2, width: 40, uppercase: true, }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 22:
      return <GenericConditional controller={controller} allow_in edit={edit} inputParams={{ width: 70, number: false, uppercase : true,  maxLength: 4 }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
    case 23:
      return <GenericSingleValue controller={controller} edit={edit} inputParams={{ maxLength: 5, width: 80 }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 24:
    case 25:
    case 26:
      return <GenericSingleValue controller={controller} edit={edit} inputParams={{ width: 160 }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 27:
      return <GenericConditional controller={controller} edit={edit} inputParams={{ width: 70, number: false, price: true, maxLength: 8 }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
    case 28:
      return <ConditionOnly controller={controller} edit={edit} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 29:
    case 30:
      return <GenericConditional controller={controller} edit={edit} filter={filter} onClose={() => callback()} onSave={handleSave} />;
    case 31:
      return <GenericConditional controller={controller} edit={edit} date inputParams={{ width: 100 }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
    case 32:
      return <GenericSingleValue controller={controller} edit={edit} inputParams={{ maxLength: 1, width: 20, uppercase: true, chars: ["Y", "N"] }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 33:
      return <GenericConditional controller={controller} edit={edit} filter={filter} onClose={() => callback()} onSave={handleSave} />;
    case 34:
      return handleSave({ ...FILTER, type: filter.value });
    case 35:
      return handleSave({ ...FILTER, type: filter.value });
    case 36:
      return <GenericSingleValue controller={controller} edit={edit} inputParams={{ maxLength: 5, width: 85, uppercase : true }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 37:
      return handleSave({ ...FILTER, type: filter.value });
    case 38:
      return <RangeConditional controller={controller} edit={edit} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 39:
      return <GenericSingleValue controller={controller} edit={edit} inputParams={{ maxLength: 4, width: 65 }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 40:
      return <GenericSingleValue controller={controller} edit={edit} inputParams={{ maxLength: 11, width: 160 }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 41:
      return <SalesCustomerTypes controller={controller} edit={edit} inputParams={{ maxLength: 1, width: 20, uppercase: true, }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 42:
      return <OptionalInputs controller={controller} edit={edit} inputParams={{ maxLength: 1, width: 20, uppercase: true, }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 43:
      return handleSave({ ...FILTER, type: filter.value });
    case 44:
    case 45:
      return <GenericSingleValue controller={controller} edit={edit} inputParams={{ maxLength: 1, width: 20, uppercase: true, }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 46:
      return handleSave({ ...FILTER, type: filter.value });
    case 47:
      return <GenericSingleValue controller={controller} edit={edit} inputParams={{ maxLength: 2, width: 20, number: true }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 48:
          return <SelectBisac controller={controller} edit={edit} inputParams={{ maxLength: 9, width: 160 }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 49:
      return <GenericSingleValue controller={controller} edit={edit} inputParams={{ maxLength: 9, width: 160 }} filter={filter} onClose={() => callback()} onSave={handleSave} />
    case 50:
      return handleSave({ ...FILTER, type: filter.value });
    case 51:
        return <RangeDynamic controller={controller} edit={edit} filter={filter} onClose={() => callback()} onSave={handleSave} />
    // case 2: return <DateRangeFilter onSave={handleSave} />;
    default: return null;
  }
}
